import { render, staticRenderFns } from "./updateout.vue?vue&type=template&id=33572fdf&scoped=true"
import script from "./updateout.vue?vue&type=script&lang=js"
export * from "./updateout.vue?vue&type=script&lang=js"
import style0 from "./updateout.vue?vue&type=style&index=0&id=33572fdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33572fdf",
  null
  
)

export default component.exports